import { getCurrentInstance, computed, ref } from '@vue/composition-api'
export default function useDatepickConfig () {
    const vm = getCurrentInstance().proxy
    const datePickConfig = ref({
        locale: {},
        minDate: '',
        onOpen: [
            vm.openCalendar
        ],
        allowInput: true,
        errorHandler: () => {}
    })
    const buttons = computed(() => (
        {
            'confirm': vm.$t('org.common.confirm'),
            'cancel': vm.$t('org.common.cancel'),
            '1MBefore': vm.$t('org.common.1MBefore'),
            '3MBefore': vm.$t('org.common.3MBefore'),
            '6MBefore': vm.$t('org.common.6MBefore')
        }
    ))
    const dateShortAndLonghand = computed(() => (
        {
            months: {
                shorthand: [
                    vm.$t('org.common.1M'),
                    vm.$t('org.common.2M'),
                    vm.$t('org.common.3M'),
                    vm.$t('org.common.4M'),
                    vm.$t('org.common.5M'),
                    vm.$t('org.common.6M'),
                    vm.$t('org.common.7M'),
                    vm.$t('org.common.8M'),
                    vm.$t('org.common.9M'),
                    vm.$t('org.common.10M'),
                    vm.$t('org.common.11M'),
                    vm.$t('org.common.12M')
                ],
                longhand: [
                    vm.$t('org.common.1M'),
                    vm.$t('org.common.2M'),
                    vm.$t('org.common.3M'),
                    vm.$t('org.common.4M'),
                    vm.$t('org.common.5M'),
                    vm.$t('org.common.6M'),
                    vm.$t('org.common.7M'),
                    vm.$t('org.common.8M'),
                    vm.$t('org.common.9M'),
                    vm.$t('org.common.10M'),
                    vm.$t('org.common.11M'),
                    vm.$t('org.common.12M')
                ]
            }
        }
    ))
    const getDatePickerConfig = () => {
        const tmpConfig = vm.datePickConfig
        tmpConfig.locale = vm.dateShortAndLonghand
        return tmpConfig
    }
    return {
        datePickConfig,
        buttons,
        dateShortAndLonghand,
        getDatePickerConfig
    }
}
